export default __webpack_public_path__ + "static/media/tradeup-logo.7a337609.svg";